// プロジェクト全体の定数を定義するファイル
export const API_URL = import.meta.env.VITE_API_URL;
